export const FILE_TYPES = {
    JPEG: 'image/jpeg',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}